<template>
  <div
    id="drawflow"
    @click.right="emitOnRightClick"
  >
    <InstructionsCard
      v-if="canInstructionsCardBeDisplayed"
      class="align-self-center"
      style="position:absolute; left: 50%; transform: translate(-50%, 0);"
    />
  </div>
</template>

<script>
  import 'drawflow/dist/drawflow.min.css'
  import Node from '@/components/Node/Node'
  import InstructionsCard from '@/components/InstructionsCard'
  import { mapGetters, mapMutations, mapState } from 'vuex'

  export default {
    name: 'Diagram',
    components: { InstructionsCard },
    data: () => ({
      currentModuleName: 'Home',
    }),
    computed: {
      ...mapState([ 'isMenuDisplayed', 'editor', 'isDiagramEmpty' ]),
      ...mapGetters([ 'getNodesOnDiagram' ]),
      canInstructionsCardBeDisplayed () {
        return this.isDiagramEmpty && !this.isMenuDisplayed
      }
    },
    mounted () {
      this.INIT_EDITOR()
      this.initDiagramEvents()
      this.registerDiagramNodes()
    },
    methods: {
      ...mapMutations([ 'INIT_EDITOR' ]),
      emitOnRightClick (param) {
        this.$emit('onRightClick', param)
      },
      initDiagramEvents () {
        this.editor.on('nodeSelected', (nodeId) => {
          this.$emit('onNodeSelected', nodeId)
        })

        this.editor.on('nodeUnselected', (nodeId) => {
          this.$emit('onNodeUnselected', nodeId)
        })

        this.editor.on('connectionCreated', (nodesObj) => {
          this.$emit('onConnectionCreated', nodesObj)
        })

        this.editor.on('connectionRemoved', (nodesObj) => {
          this.$emit('onConnectionRemoved', nodesObj)
        })
      },
      registerDiagramNodes () {
        this.editor.registerNode('Split', Node, { name: 'Split', mdiIcon: 'mdi-call-split' }, {})
        this.editor.registerNode('Send', Node, { name: 'Send', mdiIcon: 'mdi-wallet-outline' }, {})
      }
    },
  }
</script>

<style scoped>
  #drawflow {
    /* Square background. Resource: https://stackoverflow.com/questions/53425836/css-square-background-image*/
    --g: transparent 0 calc(25px - 1px), #f1f1f1 0 25px;
    background: repeating-linear-gradient(to right, var(--g)),
    repeating-linear-gradient(to bottom, var(--g)) #fff;
  }

  /* Hiding the default delete button */
  #drawflow >>> .drawflow-delete {
    display: none;
  }

  #drawflow >>> .drawflow-node {
    padding: 0;
    background: white;
  }

  #drawflow >>> .output {
     right: 10px !important;
   }

  #drawflow >>> .input {
    left: -10px !important;
  }

  #drawflow >>> .drawflow-node {
    width: 200px;
  }
</style>
